// extracted by mini-css-extract-plugin
module.exports = {"textarea":"input_textarea__1P-ZO"};